import { anelDeFoco, styledDs as styled } from '../../../styles/theme';

/**
 * Em tela estreita a tabela rola na horizontal. Quem usa teclado só consegue
 * rolar um contêiner se ele estiver na ordem de tabulação — daí o `tabIndex`
 * e o `role="region"` que o acompanha, no WorkQueue.
 */
export const TableWrap = styled.div`
  width: 100%;
  overflow-x: auto;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.lg};

  &:focus-visible {
    ${anelDeFoco('-2px')}
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: ${({ theme }) => theme.font.family};
  font-size: ${({ theme }) => theme.font.sizeDado};
  color: ${({ theme }) => theme.colors.textPrimary};

  thead th {
    text-align: left;
    font-size: ${({ theme }) => theme.font.sizeXs};
    font-weight: ${({ theme }) => theme.weight.semibold};
    text-transform: uppercase;
    letter-spacing: ${({ theme }) => theme.tracking.eyebrow};
    color: ${({ theme }) => theme.colors.textMuted};
    padding: 10px 12px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grid};
    background: ${({ theme }) => theme.colors.surface};
    white-space: nowrap;
  }

  tbody td {
    padding: 12px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grid};
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  tbody tr:hover {
    background: ${({ theme }) => theme.colors.page};
  }
`;
